import AES from '@/tools/aes.js';
import Vue from "vue";
import VueRouter from "vue-router";
import ClientPage from "./ClientPage";
import Contractrelease from "./Contractrelease";
import Dashboard from "./Dashboard";
import ElectronicContract from "./ElectronicContract";
import Hbhousing from "./Hbhousing";
import PerformancePart from "./PerformancePart";
import ReceiptOperation from "./ReceiptOperation";
import Report from "./Reports";
import UserConfig from "./UserConfig";
import WebControl from "./WebControl";
import basicdata from "./basicdata";
import contractmanagment from "./contractmanagment";
import editpassword from "./editpassword";
//信託

import { dataCeneter } from "@/data/DataCenter";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        pageTitle: "首頁",
        breadcrumb: [
          {
            text: "首頁",
            active: true,
          },
        ],
      },
    },
    ...UserConfig,
    ...Dashboard,
    ...Report,
    ...Hbhousing,
    ...editpassword,
    ...WebControl,
    ...ElectronicContract,
    ...basicdata,
    ...Contractrelease,
    ...contractmanagment,
    ...ReceiptOperation,
    ...ClientPage,
    ...PerformancePart,
    {
      path: "/login/:system",
      name: "login",
      component: () => import("@/views/Login.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/InvoiceSearch",
      name: "InvoiceSearch",
      component: () => import("@/views/InvoiceSearch.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/LoadingPage",
      name: "LoadingPage",
      component: () => import("@/views/LoadingPage.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/ElectronicVersion",
      name: "ElectronicVersion",
      component: () =>
        import("@/views/pages/ElectronicVersion/ElectronicVersion.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/MockLogin/:system",
      name: "MockLogin",
      component: () => import("@/views/Login.vue"),
      props: true,
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "/error-404",
    },
  ],
});

router.beforeEach((to, _, next) => {
  if (to.name == "MockLogin") {
    return next();
  }
  if (to.name == "ElectronicVersion") {
    return next();
  }
  if (to.name.indexOf("InvoiceSearch") != -1 || to.name == "LoadingPage"
      || to.name == "ContractmMobileUpload") {
    return next();
  }

  
  if (to.name != "login" && to.name != "error-404") {
    if (localStorage == null || localStorage.getItem("dataCenter") == null) {
      return next({ name: "login", params: { system: "class" } });
    }
    var loginToken = null;
    try{
      loginToken =  JSON.parse(AES.decrypt(localStorage.getItem("dataCenter"))).loginToken;

    }catch(e){
      loginToken =  JSON.parse(localStorage.getItem("dataCenter")).loginToken;

    }
    const isLoggedIn = loginToken != null;
    // 驗證沒有token 了話轉到登入頁面
    if (!isLoggedIn)
      return next({ name: "login", params: { system: "class" } });
  }

  // 检查特定条件，如果条件满足，则阻止页面切换
  if (to.name.indexOf("Link:") != -1 && !to.name.startsWith("")) {
    // window.open(xmlUrl, '_blank');
    console.log(WebControl);
    return next(false);
  }

  dataCeneter.user.reciprocal = dataCeneter.user.reciprocal + 1;
  dataCeneter.saveData();

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
